// i18n area 'backups' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.sq-AL.meta.json.
import type { enUS } from './backups'

export const sqAL: typeof enUS = {
  ckpt: {
    contents: 'Pranon',
    contentsHint:
      "Çfarë mund të ulet këtu. «Checkpoint-et» janë konfigurimi i grupit, «Kopjet e të dhënave» janë ato të VM-ve: dy leximet përbëhen, një destinacion mund t'i pranojë të dyja.",
    content: { checkpoints: 'Checkpoint-e', backups: 'Kopje të dhënash' },
    destinationsTitle: 'Destinacionet e backup-it',
    checkpointsTitle: 'Checkpoint-et',
    restoreTitle: 'Rikthimi',
    addDestination: 'Shto destinacion',
    addDestinationTitle: 'Shto destinacion backup-i',
    editDestinationTitle: 'Modifiko destinacionin',
    storage: 'Storage',
    storageHint:
      'Një storage dir-like (dir/NFS/CIFS/CephFS) — artefaktet janë skedarë të zakonshëm nën namespace-in e platformës.',
    schedule: 'Planifikimi',
    scheduleNone: 'Vetëm manual',
    scheduleHourly: 'Çdo orë',
    scheduleDaily: 'Ditor',
    scheduleWeekly: 'Javor',
    scheduleHour: 'Ora',
    scheduleWeekday: 'Dita',
    scheduleHint:
      'Checkpoint-et e planifikuar nuk kanë një operator që shtyp masterpass-in: sekretet e keystore-it paketohen si placeholder.',
    retention: 'Retention',
    retentionHint:
      'Sa checkpoint të planifikuar të mbahen — sweeper-i heq më të vjetrit përtej numrit. Checkpoint-et manualë dhe ata para-rikthimit nuk hiqen kurrë.',
    paused: 'Në pauzë',
    pausedHint:
      'Blackout-i i operatorit: sa zgjat pauza, në këtë destinacion nuk planifikohet dhe nuk krasitet asgjë — policy-t e të dhënave dhe checkpoint-et njësoj. Ekzekutimet në vazhdim nuk preken kurrë.',
    orphanRuns: '{n} ekzekutime jetime',
    orphanRunsHint:
      'Ekzekutime të planifikuara nga policy që nuk ekzistojnë më në këtë destinacion: asnjë retention nuk i qeveris — kurrë të numëruara, kurrë të krasitura — dhe vetëm një dorë i fshin. Lentja «backups» e tvirt diagnose emërton policy-t e hequra.',
    rescan: 'Ribirëso artefaktet',
    rescanTitle: 'Ribirësimi i artefakteve të {name}',
    rescanHint:
      'Rindërton katalogun e kopjeve rezervë (VM/CT/App) nga manifestet e artefakteve të pranishme në destinacion. Rreshtat ekzistues nuk preken kurrë; kopjet e politikave të panjohura mbeten jetime (nuk krasiten kurrë automatikisht). Hapi pas një rikthimi bootstrap.',
    masterpassDrWarning:
      'Skenari i katastrofës: disqet LUKS kthehen VETËM nga një checkpoint ME masterpass. Checkpoint-et e planifikuara paketojnë mbajtës vendi — bëni periodikisht një checkpoint manual me masterpass.',
    policy: {
      title: 'Policy të backup-it të të dhënave',
      hint: 'Policy me emër: cilat objekte (kind, tag-e, scope), sa shpesh, kur mund të niset një ekzekutim, dhe sa kopje të mbahen. Gjesti i regjistrimit i mbetet pronarit të objektit: tag-et caktohen në scope-in e tij.',
      add: 'Shto policy',
      column: 'Policy të dhënash',
      name: 'Emri',
      nameHint:
        'Etiketa e policy-t, unike brenda destinacionit. Ekzekutimet ndjekin id-në e qëndrueshme të policy-t: riemërtimi është falas; fshirja i lë ekzekutimet e saj jetimë (nuk numërohen më as nuk krasiten).',
      kindLocked: 'Familja e objekteve e një policy ekzistuese nuk ndryshohet: krijo një policy të re.',
      kindLabel: 'Objektet',
      kind: { vm: 'Makina virtuale', ct: 'Kontejnerë', app: 'App' },
      tags: 'Përzgjedhës tag-esh',
      tagsHint:
        'Çifte tag=vlerë, të ndara me presje, në AND. Tag-et dhe scope-t bosh nuk përzgjedhin asgjë — kurrë «gjithçka».',
      scopes: 'Scope-t',
      scopesHint: 'Shtigje scope-sh (nënpemë), të ndara me presje, në OR mes tyre.',
      windowStart: 'Dritarja nga',
      windowEnd: 'Dritarja deri',
      windowHint:
        'Dritarja e ekzekutimit (HH:MM, ora lokale; një fillim përtej fundit kapërcen mesnatën). Qeveris vetëm NISJEN: një ekzekutim që e tejkalon nuk vritet kurrë.',
      mode: 'Mënyra',
      modeHint: 'Inkrementali i hipën familjes së serive; një seri e këputur degradon në full, thënë në ditar.',
      modeFull: 'Full',
      modeIncremental: 'Inkremental',
      requireQuiesce: 'Kërko quiesce (guest agent)',
      paused: 'Policy në pauzë',
      retentionNone: 'Mbaj gjithçka',
      retentionCount: 'Numërim',
      retentionGfs: 'Unaza GFS',
      gfs: { keepLast: 'Të fundit', daily: 'Ditore', weekly: 'Javore', monthly: 'Mujore', yearly: 'Vjetore' },
      gfsHint:
        'Për çdo unazë mbahet backup-i më i ri i secilës prej N periudhave të fundit. Një backup i mbajtur e mban gjallë tërë zinxhirin e vet — kurrë një bazë me jetimë.',
      lastRun: 'Ekzekutimi i fundit',
      neverRan: 'asnjëherë i ekzekutuar'
    },
    lastCheckpoint: 'Checkpoint-i i fundit',
    neverRun: 'Asnjëherë i krijuar',
    createNow: 'Krijo checkpoint',
    createNowTitle: 'Krijo checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Mbron vlerat sekrete të keystore-it (argon2id → AES-256-GCM, për secilën vlerë). Nuk ruhet kurrë: mbaje mirë — pa të, një rikthim prodhon placeholder në vend të sekreteve të vërteta.',
    masterpassEmptyHint: 'Lëre bosh për të paketuar placeholder eksplicitë në vend të sekreteve.',
    createStarted: 'Checkpoint-i në proces…',
    destinationInUseError: "'{name}' përmban ende checkpoint — fshiji më parë.",
    origin: 'Origjina',
    originManual: 'manual',
    originSchedule: 'i planifikuar',
    originPreRestore: 'para-rikthim',
    originPreChange: 'para ndryshimit',
    preChangeRetention: 'Checkpoint-e para ndryshimit',
    preChangeRetentionHint:
      'Bosh = e çaktivizuar. Shkrimi i parë i konfigurimit pas një periudhe qetësie ngrin këtu gjendjen e mëparshme (origjina „para ndryshimit“); më të rinjtë ruhen deri në numrin e dhënë — retencion i vet, i krasitshëm.',
    diffTitle: 'Pamje paraprake e ndryshimeve',
    diffFailed: 'Pamja paraprake dështoi',
    diffRetry: 'Riprovo',
    diffCounts: '{changed} për t’u ndryshuar · {missing} për t’u krijuar · {extra} tepër · {equal} identike',
    diffChanged: 'ndryshon',
    diffMissing: 'do të krijohej',
    diffExtra: 'do të fshihej',
    diffJsonb: 'referencat jsonb s’mund të verifikohen para aplikimit',
    diffSecret: 'fusha të vulosura, të pakrahasueshme',
    diffMore: 'edhe {n}…',
    diffNeeded: 'Nisja armatohet kur pamja paraprake pasqyron përzgjedhjen.',
    phase: 'Gjendja',
    phaseRunning: 'në proces',
    phaseComplete: 'i plotë',
    phaseError: 'gabim',
    secrets: 'Sekretet',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholder',
    size: 'Madhësia',
    created: 'Krijuar',
    destination: 'Destinacioni',
    download: 'Shkarko .tvbk',
    deleteCheckpoint: 'Fshi checkpoint-in',
    noCheckpoints: 'Ende asnjë checkpoint — krijo një nga një destinacion.',

    // Round #156 (dialog standard): la superficie di lettura completa del
    // record di archivio — righe di dettaglio per i campi mai mostrati in tabella.
    families: 'Familjet',
    generation: 'Gjenerata',
    completedAt: 'Përfunduar më',
    errorDetail: 'Detajet e gabimit',
    manifest: 'Manifest',
    restoreHint: 'Ngarko një artefakt .tvbk: explorer-i tregon çfarë përmban, pastaj zgjidh çfarë të rikthehet dhe si.',
    uploadFile: 'Ngarko një skedar .tvbk',
    uploading: 'Duke ngarkuar…',
    uploadFailed: 'Artefakti nuk mund të hapej',
    explorerTitle: 'Përmbajtja e checkpoint-it',
    checkpointFrom: 'Checkpoint i klasterit {cluster}, krijuar më {when} ({origin}, gjenerata {generation})',
    otherCluster:
      'Ky checkpoint vjen nga një klaster TJETËR ({cluster}) — rikthimi cross-cluster vjen në një round të ardhshëm.',
    encrypted: 'i enkriptuar',
    objectsCount: '{n} objekte',
    mode: 'Mënyra',
    modeMerge: 'Merge — pajton: upsert i rreshtave të zgjedhur, nuk fshin asgjë',
    modeOverwrite:
      'Overwrite — fiton checkpoint-i: një familje e zgjedhur plotësisht zëvendësohet e tëra (rreshtat aktualë që mungojnë në checkpoint hiqen)',
    restoreMasterpassHint:
      'Masterpass-i me të cilin u krijua checkpoint-i. Pa të, sekretet e enkriptuara rikthehen si placeholder eksplicitë.',
    checkMasterpass: 'Verifiko',
    masterpassOk: 'Masterpass i saktë',
    masterpassWrong: 'Masterpass i gabuar',
    parachuteDestination: 'Destinacioni parashutë',
    parachuteHint: 'Para se të prekë ndonjë rresht, task-u krijon këtu një checkpoint automatik para-rikthimi.',
    summaryTitle: 'Çfarë do të ndodhë',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'familja e plotë',
    summaryObjects: '{n} objekte të zgjedhura',
    confirmHint:
      'Shkruaj emrin e klasterit ({name}) për të konfirmuar — një rikthim e rishkruan konfigurimin e deklaruar.',
    confirmField: 'Emri i klasterit',
    startRestore: 'Rikthe',
    restoreRunning: 'Rikthimi në proces…',
    restoreDone: 'Rikthimi u përfundua — reconciler-ët konvergojnë në deklarimin e ri.',
    restoreFailed: 'Rikthimi dështoi',
    discard: 'Hidh',
    selectionEmpty: 'Zgjidh të paktën një familje ose një objekt.'
  },

  backup: {
    intro: {
      title: 'Backup-i i të dhënave të VM-ve dhe kontejnerëve',
      subtitle: 'Tullat që përdor software-i i jashtëm i backup-it',
      whatItIs:
        'TVirt ekspozon katër primitivë: snapshot-e quiesced, ndjekjen e ndryshimeve për çdo disk, eksport NBD vetëm për lexim dhe eksportin e konfigurimit. I drejtojnë Veeam, Bacula, Acronis e të ngjashmit.',
      whatItIsNot:
        'TVirt nuk është produkt backup-i: nuk planifikon asgjë, nuk zbaton retention dhe nuk ruan asnjë arkiv të të dhënave të tua. Retention-i, katalogët dhe politikat e rikthimit i mbeten software-it që përdor tashmë.'
    },
    cbt: {
      title: 'Ndjekja e ndryshimeve',
      colVm: 'VM',
      colDisk: 'Disku',
      colState: 'Gjendja',
      colBitmaps: 'Bitmape',
      colObservedAt: 'Vëzhguar',
      colChangeId: 'Change ID',
      colMechanic: 'Mekanizmi',
      stateActive: 'Aktiv',
      stateInactive: 'Joaktiv',
      stateInconsistent: 'Jokoherent — kopja tjetër duhet të jetë e plotë',
      stateBroken: 'Zinxhiri i këputur — çaktivizo, pastaj aktivizo si zinxhir i ri',
      stateSnapshots: 'Gjithmonë aktiv — delta mes snapshoteve',
      stateUnavailable: 'I padisponueshëm në këtë disk',
      mechanic: {
        'qcow2-bitmap': 'Bitmap qcow2',
        'rbd-snapdiff': 'Diff i snapshoteve Ceph',
        'lvm-thin-delta': 'Delta e thin pool',
        none: 'Asnjë'
      },
      empty: 'Asnjë disk VM. Ndjekja lexohet për çdo disk: aktivizoje në një disk qcow2 ose merr snapshote në rbd/SAN.',
      chainBroken: 'Zinxhiri i këputur',
      chainBrokenText:
        'Këputur nga {reason}: {bitmaps}. Çaktivizo bitmap-in (zinxhiri ka humbur, kopja tjetër është e plotë), pastaj aktivizoje si zinxhir i ri.',
      lineages: 'Epoka',
      epochFrozen: 'e ngrirë në snapshotin {snapshot}',
      epochLost: 'e humbur ({cause})',
      epochRecording: 'po regjistron në kokë',
      milestones: 'Pikat kyçe (snapshote)',
      enable: 'Aktivizo ndjekjen',
      disable: 'Çaktivizo',
      reset: 'Rivendos',
      changedAreas: 'Zonat e ndryshuara',
      denied: 'Nuk keni leje në këtë VM',
      enableTitle: 'Aktivizo ndjekjen e ndryshimeve',
      disableTitle: 'Çaktivizo ndjekjen e ndryshimeve',
      resetTitle: 'Rivendos bitmap-in',
      areasTitle: 'Zonat e ndryshuara',
      bitmapName: 'Emri i bitmap-it',
      bitmapNameHint: 'Një emër i juaji: tvirt- dhe tvbk- i përkasin platformës',
      granularity: 'Granulariteti (bajte)',
      granularityHint: 'Fuqi e dyshit; parazgjedhja 65536',
      bitmap: 'Bitmap',
      disableHint: 'Heq bitmap-in dhe gjithë historinë e epokave të tij: kopja tjetër duhet të jetë e plotë.',
      resetHint: 'Zbraz bitmap-in — një bazë e re: një change ID më i vjetër se rivendosja nuk përbëhet më.',
      areasFrom: 'Nga snapshoti',
      areasTo: 'Deri te snapshoti',
      areasRun: 'Llogarit',
      areasResult: '{count} zona të ndryshuara, {bytes}',
      areasEmpty: 'Asnjë zonë e ndryshuar mes dy snapshoteve',
      areasZero: 'zero',
      areasMore: 'shfaqen të parat {shown} nga {count}',
      submit: 'Konfirmo',
      error: 'Veprimi i ndjekjes dështoi'
    },
    exports: {
      title: 'Eksporte NBD të hapura',
      colVm: 'VM',
      colDisk: 'Disku',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmap',
      colPhase: 'Faza',
      colNode: 'Nyja',
      colEndpoint: 'Endpoint',
      colExpires: 'Skadon',
      colCreated: 'Hapur',
      colError: 'Gabim',
      phase: {
        preparing: 'Në përgatitje',
        ready: 'Gati',
        closed: 'Mbyllur',
        error: 'Dështoi'
      },
      expiresIn: 'pas {minutes} min',
      expired: 'skaduar',
      empty: 'Asnjë eksport. Një sesion leximi shërben një disk në një snapshot te një klient NBD; një sesion shkrimi mbush një disk të paprekur të një VM-je të ndalur. Të dy vdesin kur skadojnë.',
      endpointHint: 'TLS me CA-në e klasterit; emri i eksportit është bileta — vdes me sesionin',
      closeDenied: 'Nuk keni leje të mbyllni eksporte të kësaj VM',
      open: 'Hap eksport NBD',
      openTitle: 'Hap një eksport NBD',
      openDisk: 'Disku',
      openBitmap: 'Bitmap (opsional)',
      openBitmapHint:
        'Publikon epokën e atij bitmap-i të ngrirë në këtë snapshot si meta-context të extenteve të ndryshuara (vetëm disqe qcow2)',
      openTtl: 'Kohëzgjatja (minuta)',
      openSubmit: 'Hap',
      openError: 'Eksporti nuk u hap dot',
      colMode: 'Mënyra',
      mode: {
        read: 'Lexim',
        write: 'Shkrim'
      },
      caCertificate: 'CA e grupit',
      caCopy: 'Kopjo PEM',
      caDownload: 'Shkarko ca-cert.pem',
      caHint: 'Shkruaje PEM-in në ca-cert.pem brenda një dosjeje private dhe lidhu me nbds://…?tls-certificates=<dosje> (nbdcopy, nbdinfo) ose --object tls-creds-x509,dir=<dosje>,endpoint=client (qemu-img)',
      caAbsent: 'Sesioni nuk mban CA (pa PKI)',
      openWrite: 'Hap eksport shkrimi',
      openWriteTitle: 'Hap një eksport shkrimi',
      openWriteIntro: 'Disku duhet të jetë i paprekur: lindur bosh, kurrë i shkruar, pa snapshot; VM-ja e ndalur. Rikthimi e MBUSH diskun, nuk e riparon. Sa kohë sesioni është i hapur, VM-ja nuk niset, nuk bën snapshot, nuk klonohet dhe disku nuk zhvendoset.',
      openWriteSubmit: 'Hap',
      openWriteError: 'Eksporti i shkrimit nuk u hap dot',
      openWriteDenied: 'Të mungon vm.restore.data në këtë VM',
      openWriteStopped: 'Ndalo VM-në për të hapur një eksport shkrimi',
      fromDescription: 'Krijo VM nga përshkrimi',
      fromDescriptionTitle: 'Krijo një VM nga një përshkrim',
      fromDescriptionIntro: 'Përshkrimi i export-vm-meta kthehet si VM e ndalur me disqe bosh të gjeometrisë së përshkruar — gati për eksportet e shkrimit, disk pas disku. Bajtët nuk kalojnë këtu: i mbart restore-disk (CLI) ose klienti NBD i produktit të backup-it.',
      fromDescriptionDoc: 'Përshkrimi (JSON)',
      fromDescriptionDocHint: 'Ngjit dokumentin e export-vm-meta, ose zgjidh skedarin',
      fromDescriptionFile: 'Zgjidh skedar…',
      fromDescriptionInvalid: 'Teksti nuk është dokument JSON',
      fromDescriptionName: 'Emri i VM-së së re',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Scope-i yt i nisjes',
      fromDescriptionStorage: 'Ruajtja e disqeve',
      fromDescriptionStorageHint: 'Çdo disk lind këtu, në formatin e parazgjedhur të ruajtjes',
      fromDescriptionMetadataStorage: 'Ruajtja e metadatave',
      fromDescriptionSameAsStorage: 'E njëjta me disqet',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Pa bridge e pa rrjet VM-ja lind pa karta',
      fromDescriptionNetwork: 'Rrjet logjik (fabric/rrjet)',
      fromDescriptionSubmit: 'Krijo',
      fromDescriptionError: 'VM-ja nuk u krijua dot',
      fromDescriptionDone: 'VM u krijua: {name}',
      fromDescriptionOpen: 'Hap VM-në',
      fromDescriptionDenied: 'Të mungon vm.create',
      fromDescriptionStillRunning: 'Krijimi është ende në vazhdim: vazhdojmë të presim'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Kopje të dhënash të VM-ve',
      titleOnVm: 'Kopje të dhënash',
      empty:
        'Asnjë kopje. Një kopje çon disqet, varstore UEFI dhe gjendjen e vTPM në një destinacion dhe i mbijeton makinës virtuale.',
      colVm: 'VM',
      colCreated: 'Marrë më',
      colPhase: 'Përfundimi',
      colDestination: 'Destinacioni',
      colContains: 'Përmbajtja',
      colSize: 'Madhësia',
      colOrigin: 'Origjina',
      colMode: 'Lloji',
      retentionChip: 'Mbajtja',
      retentionHint:
        'Mbajtja e destinacionit mund ta fshijë këtë kopje pa pyetur: lindi nga një planifikim. Kopjet manuale nuk fshihen kurrë.',
      policyRemoved: 'Policy e hequr: {name}',
      policyRemovedHint:
        'Policy që planifikoi këtë backup nuk ekziston më: asnjë retention nuk e qeveris (kurrë nuk krasitet automatikisht) — fshije me dorë kur të mos duhet më.',
      phase: {
        running: 'Në vazhdim',
        complete: 'E përfunduar',
        error: 'Dështoi'
      },
      origin: {
        manual: 'Manuale',
        schedule: 'E planifikuar'
      },
      mode: {
        full: 'E plotë',
        incremental: 'Inkrementale'
      },
      contains: {
        disks: 'Disqe',
        varstore: 'Varstore UEFI',
        vtpm: 'Gjendja vTPM',
        snapshots: 'Fotografi çasti'
      },
      vmState: {
        stopped: 'VM e fikur',
        running: 'VM në punë (i nxehtë)'
      },
      artifactClass: { metadata: 'Metatë dhëna', data: 'Të dhëna', secret: 'Sekret' },
      detail: {
        tabOverview: 'Përmbledhje',
        tabArtefact: 'Artefakt',
        id: 'Identifikues',
        scope: 'Fushëveprimi',
        vmState: 'Gjendja e VM gjatë kopjimit',
        pointInTime: 'Çasti i të dhënave',
        completedAt: 'Përfundoi më',
        node: 'Nyja që kopjoi',
        error: 'Gabim',
        path: 'Dosja në ruajtje',
        checksum: 'sha256 i manifestit',
        secretsExposed: 'Material i ndjeshëm i pashifruar',
        secretsExposedYes: 'Po — destinacioni nuk shifron',
        secretsExposedNo: 'Jo',
        baseBackup: 'Kopje bazë',
        tabManifest: 'Manifest',
        manifestHint:
          'Indeksi i hapur i artefaktit: një skedar për rresht me sha256-n e vet. Dosja verifikohet edhe pa TVirt — mjaftojnë qemu-img, tar dhe jq.',
        manifestEmpty: 'Manifesti nuk rendit skedarë.',
        manifestError: 'Manifesti nuk lexohet',
        colEntry: 'Skedar',
        colClass: 'Klasë',
        colSha: 'sha256'
      },
      create: {
        action: 'Kopjo tani',
        title: 'Kopjo tani',
        submit: 'Nis kopjen',
        destination: 'Destinacioni',
        destinationHint: 'Vetëm destinacionet që pranojnë kopje.',
        noDestinations: 'Asnjë destinacion nuk pranon kopje: krijoni një te Sistemi → Checkpoints.',
        contentsHint:
          'Udhëtojnë të gjithë disqet, varstore UEFI dhe gjendja e vTPM. Dy të fundit janë thelbi: një guest i vulosur duhet të nisë sërish.',
        error: 'Kopja nuk nisi',
        stillRunning: 'Kopja ende po vazhdon — kopjimi vazhdon edhe nëse mbyllni.',
        vmRunning:
          'Makina është {phase}: kopja rezervë kërkon një VM të qëndrueshme — të fikur për kopjimin e ftohtë, në punë për të nxehtin.'
      },
      restore: {
        action: 'Rikthe',
        title: 'Rikthe',
        intro:
          'Rikthimi është i pakthyeshëm. Zgjidhni ku kthehen të dhënat: në një makinë të re, ose mbi atë të origjinës.',
        modeNewVm: 'Rikthe në një VM të RE',
        modeNewVmHint:
          "Nuk prek asgjë nga ç'ekziston — është mundësia me të cilën verifikohet një kopje. Identifikues i ri dhe MAC të sapoprera.",
        modeOver: 'Mbishkruaj VM-në e origjinës',
        modeOverHint: 'Shkatërron të dhënat aktuale të VM-së së synuar, pa kthim. Makina duhet të jetë e fikur.',
        newName: 'Emri i VM-së së re',
        newNameHint: 'Duhet të jetë i lirë në fushëveprimin e destinacionit.',
        storage: 'Ruajtja e disqeve',
        storageHint:
          'E detyrueshme: manifesti regjistron madhësinë dhe formatin e një disku, kurrë ruajtjen ku ai qëndronte.',
        metadataStorage: 'Ruajtja për varstore dhe vTPM',
        metadataStorageHint: 'Ku ulen identiteti UEFI dhe gjendja e vTPM.',
        sameAsStorage: 'E njëjta si e disqeve',
        bridge: 'Bridge i hostit',
        bridgeHint:
          'Çdo kartë rrjeti e regjistruar kthehet në këtë bridge me një MAC të re. Lënë bosh, VM lind pa karta — parazgjedhja më e sigurt.',
        overwriteTitle: 'Jeni gati të mbishkruani këtë VM',
        overwriteName: 'Emri',
        overwriteId: 'Identifikues',
        overwriteDisks: 'Disqet që do të rishkruhen',
        overwriteNoDisks: 'Asnjë disk.',
        overwriteKeeps:
          'Të paprekur mbeten identifikuesi, emri, fushëveprimi, kartat e rrjetit dhe MAC-të: një kopje janë TË DHËNAT, konfigurimi është checkpoint.',
        confirmField: 'Emri i VM-së',
        confirmHint: 'Shkruani {name} për të konfirmuar.',
        targetLoading: 'Po lexohet VM-ja e synuar…',
        targetRunning: 'VM-ja e synuar është {phase}: rikthimi rishkruan bajtët nën guest, prandaj e do të fikur.',
        targetGone: 'VM-ja e origjinës nuk lexohet më: mbetet rikthimi në një VM të re.',
        onlyComplete: 'Kopja është {phase}: vetëm një kopje e përfunduar mund të rikthejë.',
        submitNewVm: 'Rikthe në VM-në e re',
        submitOver: 'Mbishkruaj',
        error: 'Rikthimi nuk nisi',
        stillRunning: 'Rikthimi ende po vazhdon — kopjimi i disqeve të plota kërkon kohë.'
      }
    },
    guest: {
      title: {
        ct: 'Kopjet rezervë të të dhënave të kontejnerëve',
        app: 'Kopjet rezervë të të dhënave të App-eve'
      },
      tabTitle: 'Kopjet rezervë',
      empty: 'Asnjë kopje. Një kopje çon të dhënat e qëndrueshme në një destinacion dhe i mbijeton objektit të vet.',
      colSubject: {
        ct: 'Kontejner',
        app: 'App'
      },
      colCreated: 'Marrë',
      colPhase: 'Përfundimi',
      colDestination: 'Destinacioni',
      colContains: 'Përmbajtja',
      colSize: 'Madhësia',
      colOrigin: 'Origjina',
      policyRemoved: 'Policy e hequr: {name}',
      policyRemovedHint:
        'Policy që planifikoi këtë backup nuk ekziston më: asnjë retention nuk e qeveris (kurrë nuk krasitet automatikisht) — fshije me dorë kur të mos duhet më.',
      phase: {
        running: 'Në vazhdim',
        complete: 'Përfunduar',
        error: 'Dështoi'
      },
      origin: {
        manual: 'Manuale',
        schedule: 'E planifikuar'
      },
      state: {
        stopped: 'Objekti i ndalur',
        running: 'Objekti në punë (i ngrirë)'
      },
      contains: {
        rootfs: 'Pema rootfs',
        config: 'Konfigurimi',
        volumes: 'Vëllimet e qëndrueshme',
        root: 'Root i qëndrueshëm'
      },
      artifactClass: {
        metadata: 'Metadata',
        data: 'Të dhëna',
        secret: 'Sekret'
      },
      create: {
        action: 'Bëj kopje tani',
        title: 'Kopje rezervë e re',
        submit: 'Nis kopjen',
        error: 'Kopja nuk nisi',
        destination: 'Destinacioni',
        destinationHint: 'Vetëm destinacionet që pranojnë kopje rezervë të dhënash.',
        noDestinations:
          'Asnjë destinacion nuk pranon kopje rezervë të dhënash: shtojini një destinacioni «Kopje rezervë të dhënash».',
        hint: {
          ct: 'Udhëton e gjithë pema rootfs, besnikërisht (pronarë numerikë, xattr, ACL), plus konfigurimi i deklaruar në manifest. Një kontejner në punë NGRIHET për gjithë paketimin: kopje crash-consistent, e deklaruar.',
          app: 'Udhëtojnë VETËM vëllimet e qëndrueshme (dhe root-i i qëndrueshëm), plus konfigurimi në manifest. Efemerja përjashtohet me ratifikim dhe manifesti e emërton; vlerat env të deklaruara sekrete nuk udhëtojnë.'
        },
        stillRunning: 'Kopja ende në vazhdim — paketimi i pemëve të tëra kërkon kohë.'
      },
      detail: {
        tabOverview: 'Përmbledhje',
        tabManifest: 'Manifesti',
        id: 'Identifikuesi',
        scope: 'Fusha',
        state: 'Gjendja në kopjim',
        pointInTime: 'Të dhënat në çastin',
        completedAt: 'Përfunduar më',
        node: 'Nyja që kopjoi',
        error: 'Gabim',
        path: 'Dosja në magazinim',
        checksum: 'sha256 i manifestit',
        manifestHint:
          'Indeksi i artefaktit: një zë për skedar me sha256-n e vet — pa hash-et, «kopja është aty» është akt besimi.',
        manifestError: 'Manifesti nuk mund të lexohet',
        manifestEmpty: 'Asnjë artefakt në manifest.',
        colEntry: 'Skedar',
        colClass: 'Klasa',
        colSha: 'sha256',
        excluded: 'Përjashtuar me ratifikim (nuk udhëton)',
        secretKeys: 'Çelësat env sekretë të lënë jashtë (#307) — rifutini pas një rikthimi'
      },
      restore: {
        action: 'Rikthe',
        title: 'Rikthimi',
        submit: 'Rikthe',
        error: 'Rikthimi nuk nisi',
        stillRunning: 'Rikthimi ende në vazhdim — shpaketimi i pemëve të tëra kërkon kohë.',
        onlyComplete: 'Kopja është {phase}: vetëm një kopje e përfunduar mund të rikthejë.',
        asNew: {
          ct: 'Në një kontejner TË RI — nuk shkatërron asgjë: gjesti me të cilin verifikohet një kopje',
          app: 'Në një App TË RE — nuk shkatërron asgjë: gjesti me të cilin verifikohet një kopje'
        },
        over: {
          ct: 'MBI kontejnerin burim — zëvendësohet e gjithë pema rootfs',
          app: 'MBI App-in burim — zëvendësohet përmbajtja e çdo vëllimi të qëndrueshëm'
        },
        name: 'Emri i objektit të ri',
        storage: 'Magazinimi',
        storageHint: "Ku zbresin të dhënat e rikthyera — manifesti s'e regjistron kurrë pool-in e humbur.",
        storageDeclared: 'Magazinimet e deklaruara në manifest',
        bridge: 'Bridge i host-it',
        bridgeHint:
          'Çdo kartë e regjistruar kthehet në këtë bridge me një MAC të freskët. Bosh = lind i palidhur, parazgjedhja më e sigurt.',
        node: 'Nyja',
        nodeHint: "Anëtari ku App-i rilind: nyja është identitet klasteri dhe s'vjen kurrë nga manifesti.",
        secretKeysWarning:
          'Vlerat env të deklaruara sekrete nuk udhëtojnë në kopje: kopja e rilindur i do të rifutura (log-u i task-ut emërton çelësat).',
        overInventory: 'Jeni duke mbishkruar këtë objekt',
        confirmType: 'Shkruani {name} për të konfirmuar',
        targetGone: "Objekti burim s'mund të lexohet më: mbetet rikthimi si i ri.",
        targetLoading: 'Duke lexuar objektin e synuar…',
        targetRunning: 'Objekti i synuar është në punë: rikthimi zëvendëson bajtet nën mysafirin dhe e do të ndalur.'
      }
    }
  }
}
